import marketCarts from 'Assets/js/Vuex/Store/stores/marketCarts';

const mutations = {
  resetB2bCarts(state, b2bCarts) {
    state.b2bCarts = b2bCarts;
  },

  logoutState(state) {
    state.loaded = false;
    state.menuLoaded = false;
    state.b2b = {};
    state.b2bUser = false;
    state.b2bCarts = {
      global: {
        initiated: false,
        attachUserOpenInCart: false,
        giftMessage: '',
        discountCodes: [],
        products: []
      },
      markets: [],
      carts: [],
      marketCarts
    };
    state.cart = {};
    state.cartLoaded = false;
    state.user = {
      acceptsMarketing: false,
      addresses: {
        edges: {}
      },
      date_of_birth: null,
      defaultAddress: null,
      email: null,
      firstName: null,
      gender: null,
      id: null,
      lastIncompleteCheckout: null,
      lastName: null,
      locale: null,
      orders: {
        edges: {}
      },
      token: null,
      password: null,
      phone: null,
      prefix: null,
      b2bUser: false,
      b2bUserList: [],
      b2b: {
        id: null,
        role: null,
        companyId: null
      }
    };
    state.wishlist = [];
    state.wishlistLenght = 0;
  },

  resetState(state) {
    state.wishlistLenght = 0;
    state.devMode = window.global_theme_object.dev_mode === 'true';
    state.b2b = {
      orders: [],
      orderPagination: null,
      totalOrders: 0
    };
    state.b2bCarts = {};
    state.user = {
      acceptsMarketing: false,
      addresses: {
        edges: {}
      },
      date_of_birth: null,
      defaultAddress: null,
      email: '',
      firstName: null,
      gender: null,
      id: null,
      lastIncompleteCheckout: null,
      lastName: null,
      locale: null,
      orders: {
        edges: {}
      },
      token: null,
      password: null,
      phone: null,
      prefix: null,
      b2bUser: false,
      b2bUserList: [],
      b2b: {
        id: null,
        role: null,
        companyId: null
      }
    };
    state.wishlist = [];
    state.b2bUser = false;
    state.cart = {};
    state.recommendedProducts = [];
  },
  resetCart(state) {
    state.cart = {};
  }
};

export default mutations;
